import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type TagSeverity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast';

/**
 * A small status chip.
 *
 * No ng-primitives equivalent — a tag has no behaviour or interaction
 * state to abstract, so this stays plain markup. Presentational only:
 * it carries no role, because the text inside labels whatever it sits
 * next to rather than being a live region.
 *
 * Intentionally unstyled; severity resolves to a class name for the
 * design system to attach to.
 */
@Component({
  selector: 'hh-tag',
  standalone: true,
  template: `<span [class]="classes()">{{ value() }}<ng-content /></span>`,
  styleUrl: './hh-tag.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HhTagComponent {
  readonly value = input('');

  /** Unset keeps the brand palette, matching the previous default. */
  readonly severity = input<TagSeverity | undefined>(undefined);

  protected readonly classes = computed(
    () => `hh-tag hh-tag--${this.severity() ?? 'primary'}`,
  );
}
